import { render } from "./QuotaBalanceTab.vue?vue&type=template&id=23c45431&scoped=true"
import script from "./QuotaBalanceTab.vue?vue&type=script&lang=js"
export * from "./QuotaBalanceTab.vue?vue&type=script&lang=js"

import "./QuotaBalanceTab.vue?vue&type=style&index=0&id=23c45431&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c45431"]])

export default __exports__